import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { classToPlain, plainToClass } from 'class-transformer';
import 'rxjs/add/observable/interval';
import 'rxjs/add/observable/of';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/takeLast';
import 'rxjs/add/operator/takeUntil';
import 'rxjs/add/operator/takeWhile';
import { Observable } from 'rxjs/Observable';
import { fromPromise } from 'rxjs/observable/fromPromise';

export class Settings {
    durchlaeufe = 1;
    anschlaege = 180;
    rate = 1.2;
    refsize = 50; // 50mm;
    realsizex = 58.5;
    realsizey = 58.5;
}

@Injectable()
export class SettingsProvider {

    public settings: Settings = null;

    constructor(
        private storage: Storage
    ) {
    }

    public load(): Observable<Settings> {
        if (this.settings != null) {
            return Observable.of(this.settings);
        }
        return fromPromise(this.storage.get('settings'))
            .map(settings => {
                if (settings) {
                    this.settings = plainToClass<Settings, Object>(Settings, settings);
                } else {
                    this.settings = new Settings();
                }
                return this.settings;
            });
    }

    public save(): void {
        const obj = classToPlain(this.settings);
        this.storage.set('settings', obj);
    }
}



// WEBPACK FOOTER //
// ./src/provider/settings-service.ts